import React, { Children } from 'react';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-[#D4A24C] selection:text-white" data-id="element-334">
      {/* Simple Header */}
      <header className="bg-white border-b border-slate-200 py-6 sticky top-0 z-50" data-id="element-335">
        <div className="max-w-4xl mx-auto px-6 flex justify-between items-center" data-id="element-336">
          <a href="/" className="text-2xl font-bold text-[#0F172A] tracking-tight" data-id="element-337">
            Nationwide<span className="text-[#D4A24C]" data-id="element-338">Home Buyers</span>
          </a>
          <a href="/" className="inline-flex items-center text-[#0F172A] font-medium hover:text-[#D4A24C] transition-colors text-sm" data-id="element-339">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-340" />
            Back to Home
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="py-16 md:py-24 px-6" data-id="element-341">
        <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-100" data-id="element-342">
          <div className="w-10 h-10 bg-[#D4A24C]/10 rounded-lg flex items-center justify-center mb-6" data-id="element-343">
            <ShieldCheckIcon className="w-5 h-5 text-[#D4A24C]" data-id="element-344" />
          </div>

          <h1 className="text-3xl md:text-4xl font-extrabold text-[#0F172A] mb-4" data-id="element-345">
            Privacy Policy
          </h1>
          <p className="text-slate-500 mb-12" data-id="element-346">Last Updated: October 15, 2023</p>

          <div className="space-y-8 text-slate-600 leading-relaxed" data-id="element-347">
            <section data-id="element-348">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-349">
                1. Information We Collect
              </h2>
              <p className="mb-4" data-id="element-350">
                When you use NationwideHomeBuyers.com, we may collect the
                following types of information:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-351">
                <li data-id="element-352">
                  <strong data-id="element-353">Personal Information:</strong> Name, email address,
                  phone number, and property address when you submit a form.
                </li>
                <li data-id="element-354">
                  <strong data-id="element-355">Property Details:</strong> Information about the
                  condition, features, and status of the property you wish to
                  sell.
                </li>
                <li data-id="element-356">
                  <strong data-id="element-357">Usage Data:</strong> IP address, browser type, pages
                  visited, and time spent on our website, collected via cookies
                  and analytics tools.
                </li>
              </ul>
            </section>

            <section data-id="element-358">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-359">
                2. How We Use Your Information
              </h2>
              <p className="mb-4" data-id="element-360">We use the collected information to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-361">
                <li data-id="element-362">Evaluate your property and generate a cash offer.</li>
                <li data-id="element-363">
                  Communicate with you regarding your property submission.
                </li>
                <li data-id="element-364">Improve our website, services, and marketing efforts.</li>
                <li data-id="element-365">Comply with legal obligations.</li>
              </ul>
            </section>

            <section data-id="element-366">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-367">
                3. SMS and Communication Consent
              </h2>
              <p data-id="element-368">
                By providing your phone number, you consent to receive calls and
                text messages from us regarding your property inquiry. Message
                and data rates may apply. You can opt out of SMS communications
                at any time by replying "STOP" to any message.
              </p>
            </section>

            <section data-id="element-369">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-370">
                4. Information Sharing
              </h2>
              <p data-id="element-371">
                We do not sell your personal information to third parties. We
                may share your information with trusted partners (such as title
                companies or local real estate partners) solely for the purpose
                of facilitating the purchase of your property.
              </p>
            </section>

            <section data-id="element-372">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-373">
                5. Cookies and Tracking
              </h2>
              <p data-id="element-374">
                Our website uses cookies to enhance user experience and analyze
                site traffic. You can choose to disable cookies through your
                browser settings, though some features of the site may not
                function properly.
              </p>
            </section>

            <section data-id="element-375">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-376">
                6. Data Security
              </h2>
              <p data-id="element-377">
                We implement reasonable security measures to protect your
                personal information from unauthorized access, alteration, or
                disclosure. However, no method of transmission over the internet
                is 100% secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section data-id="element-378">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-379">
                7. Third-Party Links
              </h2>
              <p data-id="element-380">
                Our website may contain links to third-party websites. We are
                not responsible for the privacy practices or content of those
                sites. We encourage you to read the privacy policies of any site
                you visit.
              </p>
            </section>

            <section data-id="element-381">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-382">
                8. Children's Privacy
              </h2>
              <p data-id="element-383">
                Our services are not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                children.
              </p>
            </section>

            <section data-id="element-384">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-385">
                9. Changes to This Policy
              </h2>
              <p data-id="element-386">
                We may update this Privacy Policy from time to time. Any changes
                will be posted on this page with an updated revision date.
              </p>
            </section>

            <section data-id="element-387">
              <h2 className="text-xl font-bold text-[#0F172A] mb-3" data-id="element-388">
                10. Contact Us
              </h2>
              <p className="mb-4" data-id="element-389">
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <address className="not-italic text-slate-600" data-id="element-390">
                <p data-id="element-391">NationwideHomeBuyers.com</p>
                <p data-id="element-392">7901 4th St N ste 300</p>
                <p data-id="element-393">St Petersburg, FL 33702</p>
                <p className="mt-2" data-id="element-394">
                  Email:{' '}
                  <a href="mailto:info@nationwidehomebuyers.com" className="text-[#D4A24C] hover:underline" data-id="element-395">
                    info@nationwidehomebuyers.com
                  </a>
                </p>
                <p data-id="element-396">
                  Phone:{' '}
                  <a href="tel:+18556052101" className="text-[#D4A24C] hover:underline" data-id="element-397">
                    1-855-605-2101
                  </a>
                </p>
              </address>
            </section>
          </div>
        </div>
      </main>
    </div>;
}